import { DeleteModal } from '@presentation/components/templates'

type Props = {
  id: string
  onDelete: () => void
}

const DeleteLocalModal: React.FC<Props> = ({ id, onDelete }) => {
  const modalConfigs = {
    id,
    path: '/locais',
    nameForTitle: 'Local',
    onDelete
  }

  return <DeleteModal {...modalConfigs} />
}

export default DeleteLocalModal
